import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Fade from 'react-reveal/Fade';
import { Element, animateScroll as scroll, scroller } from 'react-scroll'; // eslint-disable-line

import clothingImg from '../../static/img/shop_page/shop_clothing.png';
import musicImg from '../../static/img/shop_page/shop_music.png';
import videoImg from '../../static/img/shop_page/shop_video.png';
import wellnessImg from '../../static/img/shop_page/shop_wellness.png';
import accessoriesImg from '../../static/img/shop_page/shop_accessories.png';
import bestsellingImg from '../../static/img/shop_page/shop_bestselling.png';
import saleImg from '../../static/img/shop_page/shop_sale.png';
import openImg from '../../static/img/shop_page/shop_open.png';

const styles = theme => ({
  actionArea: {
    textAlign: 'right',
    padding: theme.spacing(2),
  },
  gridList: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(6),
    backgroundColor: '#FAFAFA',
    [theme.breakpoints.down(900)]: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(3),
    },
  },
  hoverEffect: {
    '&:hover': {
      opacity: '0.8',
    },
    '-webkit-transition': 'all 0.4s ease',
    '-moz-transition': 'all 0.4s ease',
    '-o-transition': 'all 0.4s ease',
    '-ms-transition': 'all 0.4s ease',
    transition: 'all 0.4s ease',
  },
  fullBackground: {
    backgroundSize: 'cover',
  },
  tileImg: {
    width: '100%',
  },
  imgOverlay: {
    // width: '100%',
    backgroundColor: 'black',
  },
  img1: {
    height: '450px',
    backgroundImage: `url(${clothingImg})`,
  },
  img2: {
    height: '300px',
    backgroundImage: `url(${musicImg})`,
  },
  img3: {
    height: '150px',
    backgroundImage: `url(${wellnessImg})`,
  },
  img4: {
    height: '150px',
    backgroundImage: `url(${videoImg})`,
  },
  img5: {
    height: '300px',
    backgroundImage: `url(${accessoriesImg})`,
  },
  panelOpen: {
    padding: theme.spacing(2),
  },
  panelClosed: {
    display: 'none',
  },
  panelImg: {
    width: '100%',
    height: 'auto',
  },
  sectionHeader: {
    letterSpacing: '3px',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down(900)]: {
      fontSize: '2em',
    },
    [theme.breakpoints.down(650)]: {
      fontSize: '1.5em',
    },
  },
  sectionTitle: {
    textAlign: 'center',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down(900)]: {
      fontSize: '1em',
      marginBottom: theme.spacing(8),
    },
    [theme.breakpoints.down(650)]: {
      fontSize: '.7em',
      marginBottom: theme.spacing(5),
    },
  },
  button: {
    marginTop: theme.spacing(2),
  },
});

class ShopHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      panel: 'panel1',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, thePanel) {
    this.setState({ panel: thePanel });
  }

  render() {
    const { classes } = this.props;
    const { panel } = this.state;
    return (
      <React.Fragment>
        <div className={classes.actionArea}>
          <Button href="/shop/cart" className={classes.action}>View Cart</Button>
          <Button href="/shop/checkout" className={classes.action} color="secondary">Checkout Now</Button>
        </div>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <a href="https://niawear.com">
              <div className={classes.imgOverlay}>
                <div className={classNames(classes.img1, classes.hoverEffect, classes.fullBackground)} />
              </div>
            </a>
          </Grid>
          <Grid item xs={6} sm={3}>
            <a href="/shop/music">
              <div className={classes.imgOverlay}>
                <div className={classNames(classes.img2, classes.hoverEffect, classes.fullBackground)} />
              </div>
            </a>
            <a href="https://niaondemand.com/therapeutic">
              <div className={classes.imgOverlay}>
                <div className={classNames(classes.img3, classes.hoverEffect, classes.fullBackground)} />
              </div>
            </a>
          </Grid>
          <Grid item xs={6} sm={3}>
            <a href="/shop/video">
              <div className={classes.imgOverlay}>
                <div className={classNames(classes.img4, classes.hoverEffect, classes.fullBackground)} />
              </div>
            </a>
            <a href="https://niawear.com/collections/accessories">
              <div className={classes.imgOverlay}>
                <div className={classNames(classes.img5, classes.hoverEffect, classes.fullBackground)} />
              </div>
            </a>
          </Grid>
        </Grid>

        <Grid container justifyContent="center" className={classes.gridList}>
          <Grid item xs={4}>
            <Button onClick={e => this.handleClick(e, 'panel1')}>
              <img src={bestsellingImg} alt="open" className={classNames(classes.tileImg, classes.hoverEffect)} />
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button onClick={e => this.handleClick(e, 'panel2')}>
              <img src={saleImg} alt="open" className={classNames(classes.tileImg, classes.hoverEffect)} />
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button onClick={e => this.handleClick(e, 'panel3')}>
              <img src={openImg} alt="open" className={classNames(classes.tileImg, classes.hoverEffect)} />
            </Button>
          </Grid>
        </Grid>

        <Element className={panel === 'panel1' ? classes.panelOpen : classes.panelClosed}>
          <Fade in={panel === 'panel1'}>
            <Grid container>
              <Grid item xs={4}>
                <Typography variant="h6" color="textSecondary" className={classes.sectionTitle}>Nia's Best Selling</Typography>
              </Grid>
              <Grid item xs={4}>
                <hr />
                <hr />
              </Grid>
              <Grid item xs={4}>
                <hr />
                <hr />
              </Grid>
            </Grid>
          </Fade>
          <Fade left in={panel === 'panel1'}>
            <Grid container>
              <Grid item xs={6}>
                <Typography className={classes.sectionHeader} variant="h3" color="textSecondary">Great Pants</Typography>
                <Typography>More about those great pants</Typography>
                <Button variant="outlined" className={classes.button}>Show me dem pants</Button>
              </Grid>
              <Grid item xs={6}>
                <img src={clothingImg} alt="panel img" className={classes.panelImg} />
              </Grid>
            </Grid>
          </Fade>
        </Element>
        <Element className={panel === 'panel2' ? classes.panelOpen : classes.panelClosed}>
          <Fade in={panel === 'panel2'}>
            <Grid container>
              <Grid item xs={4}>
                <hr />
                <hr />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h6" color="textSecondary" className={classes.sectionTitle}>Sale Live Now!</Typography>
              </Grid>
              <Grid item xs={4}>
                <hr />
                <hr />
              </Grid>
            </Grid>
          </Fade>
          <Fade left in={panel === 'panel2'}>
            <Grid container>
              <Grid item xs={6}>
                <Typography className={classes.sectionHeader} variant="h3" color="textSecondary">Sale</Typography>
                <Typography>More about the sale</Typography>
                <Button variant="outlined" className={classes.button}>Spend all your monies</Button>
              </Grid>
              <Grid item xs={6}>
                <img src={clothingImg} alt="panel img" className={classes.panelImg} />
              </Grid>
            </Grid>
          </Fade>
        </Element>
        <Element className={panel === 'panel3' ? classes.panelOpen : classes.panelClosed}>
          <Fade in={panel === 'panel3'}>
            <Grid container>
              <Grid item xs={4}>
                <hr />
                <hr />
              </Grid>
              <Grid item xs={4}>
                <hr />
                <hr />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h6" color="textSecondary" className={classes.sectionTitle}>Nia&apos;s Newest Routine</Typography>
              </Grid>
            </Grid>
          </Fade>
          <Fade left in={panel === 'panel3'}>
            <Grid container>
              <Grid item xs={6}>
                <Typography className={classes.sectionHeader} variant="h3" color="textSecondary">Routine Collection</Typography>
                <Typography>More about the routine collection</Typography>
                <Button variant="outlined" className={classes.button}>Cop that here</Button>
              </Grid>
              <Grid item xs={6}>
                <img src={clothingImg} alt="panel img" className={classes.panelImg} />
              </Grid>
            </Grid>
          </Fade>
        </Element>
      </React.Fragment>
    );
  }
}

ShopHome.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ShopHome);
